module.exports = __webpack_public_path__ + "411e6c8dfa8a3e76ae66d4491bbc5f7e.png";